module.exports = __webpack_public_path__ + "img/LG-cardart-Alik'r.caa4b134.png";